import * as React from 'react';

interface ViewMessageRatesProps {
  klass?: string;
  linkName?: string;
}

export const ViewMessageRates = ({ klass, linkName }: ViewMessageRatesProps) => {
  const handleOpen = () => {
    window.open(`${window.location.origin}/messaging_rates`);
  };

  return (
    <span
      role="button"
      tabIndex={0}
      style={{ cursor: 'pointer' }}
      className={`mt-10 ${klass}`}
      onClick={handleOpen}
      onKeyPress={handleOpen}
    >
      {linkName}
    </span>
  );
};

ViewMessageRates.defaultProps = {
  klass: 'link-blue',
  linkName: 'View Messaging Rates',
};
